import { Editor } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { Heading } from './Heading';
import { History } from './History';
import { Links } from './Links';
import { List } from './List';
import { Media } from './Media';
import { Other } from './Other';
import { Paragraph } from './Paragraph';

import classes from './BlockTools.module.scss';

export interface BlockToolsProps {
  editor: Editor;
}

export const BlockTools: FunctionComponent<BlockToolsProps> = ({ editor }) => {
  return (
    <div className={classes['block-tools']}>
      <History editor={editor} />
      <Paragraph editor={editor} />
      <Heading editor={editor} />
      <List editor={editor} />
      <Links editor={editor} />
      <Media editor={editor} />
      <Other editor={editor} />
    </div>
  );
};
